queryMatches = (first, second) ->
  first.toLowerCase().indexOf( second.toLowerCase().trim() ) != -1

App.DishGroupEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()
  needs: [ 'dish-groups' ]

  env:     Em.inject.service('environment')

  isStepperMode: Em.computed.equal('dishGroup.view_type', 'stepper')
  isSelectMode: Em.computed.equal('dishGroup.view_type', 'select')


  needs: [ 'dish-groups' ]
  dishGroupBinding: 'model'
  dishGroupsBinding: 'controllers.dish-groups.index'
  currencyUnit: Em.computed.alias('session.currency.unit')
  enabledCustomRestaurantPrice: Em.computed.alias('dishGroup.organization.features.dish_restaurant_prices')

  addPromise: null
  actions:
    cancel: ->
      dishGroup = @get('dishGroup')

      if dishGroup.get('isDirty') or dishGroup.get('isNew')
        # todo i18n
        return unless confirm 'Отменить изменения?'
        dishGroup = @get('dishGroup')
        dishGroup.rollback()

      @send('goBackToDishGroupsList')

      false

    deleteDishGroupItem: (dish) ->
      @get('dishGroup.relatedDishes').removeObject(dish) if confirm('Удалить блюдо?')
      false


    deleteDishGroup: ->
      # todo i18n
      return unless confirm 'Удалить группу?'

      dishGroup = @get('dishGroup')
      dishGroup.destroyRecord()
      .then =>
        @transitionToRoute('dish-groups')

      false

    saveDishGroup: ->
      dishGroup = @get('dishGroup')

      wasNew = dishGroup.get('isNew')
      dishGroup.set('dishes', dishGroup.get('relatedDishes').map (dish) => {
        id: dish.get('id')
      })

      @set('isLoading', true)
      dishGroup.save()
      .catch =>
        @get('notifier').pushNotification
          type: 'error'
          # todo i18n
          title: 'Ошибка сохранения'
          message: 'Комбо не сохранено, проверьте введенные данные.'
          duration: 30000
      .then (data) =>
        @get('notifier').pushNotification
          type: 'success'
          # todo i18n
          title: 'Комбо сохранено'
          duration: 3000


        @transitionToRoute('dish-groups') if wasNew
      .finally =>
        @set('isLoading', false)

      false

    queryDishes: (defer, query) ->
      organization = @get('organization')

      @store.find('dish', search: query)
      .then(defer.resolve, defer.reject)

      false
